import type { CabysItem, Company, GeoOption, TaxpayerInfo } from '@facture/contracts'
import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query'
import { api } from './api'

const DAY = 24 * 60 * 60 * 1000

export const catalogQueries = {
  provinces: () =>
    queryOptions({
      queryKey: ['catalog', 'provinces'],
      queryFn: () => api.get<GeoOption[]>('/catalog/provinces', { global: true }),
      staleTime: DAY,
    }),
  cantons: (province?: string | null) =>
    queryOptions({
      queryKey: ['catalog', 'cantons', province],
      queryFn: () => api.get<GeoOption[]>('/catalog/cantons', { global: true, query: { province } }),
      enabled: !!province,
      staleTime: DAY,
    }),
  districts: (province?: string | null, canton?: string | null) =>
    queryOptions({
      queryKey: ['catalog', 'districts', province, canton],
      queryFn: () =>
        api.get<GeoOption[]>('/catalog/districts', { global: true, query: { province, canton } }),
      enabled: !!province && !!canton,
      staleTime: DAY,
    }),
  barrios: (province?: string | null, canton?: string | null, district?: string | null) =>
    queryOptions({
      queryKey: ['catalog', 'barrios', province, canton, district],
      queryFn: () =>
        api.get<GeoOption[]>('/catalog/barrios', { global: true, query: { province, canton, district } }),
      enabled: !!province && !!canton && !!district,
      staleTime: DAY,
    }),
}

export function useCabysSearch(search: string) {
  return useQuery({
    queryKey: ['catalog', 'cabys', search],
    queryFn: ({ signal }) =>
      api.get<CabysItem[]>('/catalog/cabys', { global: true, query: { search }, signal }),
    placeholderData: keepPreviousData,
    staleTime: DAY,
  })
}

export function fetchTaxpayer(identification: string) {
  return api.get<TaxpayerInfo>(`/catalog/taxpayer/${identification}`, { global: true })
}

export const companyQuery = () =>
  queryOptions({
    queryKey: ['company'],
    queryFn: () => api.get<Company>('/company'),
  })
